import React from 'react';
import { useGlobal, useDispatch } from 'reactn';
import { Formik, Form } from 'formik';
import { Link } from 'react-router-dom';
import { alert, Page, Input, Button } from 'equasion-lib';
import logo from '@/lib/images/logos/logo-white.svg';
import Background from '@/lib/images/login-bg.svg';
import { signInValidation, signInDefaults } from './SignIn.validation';
import './SignIn.scss';

function SignIn({ signIn }: { signIn: any }) {
  const login = useDispatch('login');

  const submitSignIn = async (data, actions) => {
    const { setSubmitting } = actions;

    try {
      await signIn({
        variables: { email: data.email, password: data.password }
      });
      login();
    } catch (e) {
      alert('Error', e.message, 4, 'error');
      console.log(e);
    }
    setSubmitting(false);
  };

  return (
    <Page className="page sign-in">
      <div className="main-background">
        <img src={Background} />
      </div>

      <Formik
        initialValues={signInDefaults()}
        validationSchema={signInValidation()}
        validateOnBlur={false}
        onSubmit={submitSignIn}
      >
        {({ isSubmitting }) => (
          <Form>
            <div className="logo-badge">
              <img src={logo} alt="logo" />
            </div>
            <Input name="email" label="Email" autoComplete="email" />

            <Input
              name="password"
              inputType="password"
              autoComplete="password"
              label="Password"
            />
            <Button
              type="primary"
              size="large"
              isSubmit
              disabled={isSubmitting}
              fullWidth
            >
              Sign In
            </Button>
            <Link className="nav-link" to="/reset-password">
              <Button type="link" size="compact">
                Forgot password
              </Button>
            </Link>
            <p className="tos-wrapper">
              By signing in, you agree to the &nbsp;
              <a href="https://rxerp.com/terms-of-service" target="_blank">
                Terms of Service
              </a>
            </p>
            {/* <Button type="link" onClick={() => setSignInOption('register')}>
            Register
          </Button> */}
          </Form>
        )}
      </Formik>
    </Page>
  );
}

export default SignIn;
